import React, { useEffect, useRef, useState } from 'react';
import API_BASE_URL from "../../../apiConfig";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const AddressUpdateAdminReport = () => {
  const [addressData, setAddressData] = useState([]);
  const tableRef = useRef(null);

  // 🔹 Fetch Address Update Records
  useEffect(() => {
    const fetchAddressData = async () => {
      try {
        const authToken = localStorage.getItem("authToken");

        const response = await fetch(`${API_BASE_URL}/AddressUpdate/GetAddressUpdateRecords`,
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${authToken}`,
            }
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        let data = await response.json();

        data = data.map((record, index) => ({
          ...record,
          SrNo: index + 1
        }));

        setAddressData(data);
      } catch (error) {
        console.error('Failed to fetch address update records:', error);
      }
    };

    fetchAddressData();
  }, []);

  // 🔹 Update Status
  const handleStatusChange = async (registrationNo, newStatus) => {
    const comment = prompt("Enter comment for this status change:");
    if (!comment) return;

    try {
      const authToken = localStorage.getItem("authToken");

      const response = await fetch(`${API_BASE_URL}/AddressUpdate/updateStatus/${registrationNo}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({ status: newStatus, comment }),
        }
      );

      if (!response.ok) throw new Error("Failed to update status");

      // ✅ FIX: Use String() comparison to ensure the row is found and updated
      setAddressData(prev =>
        prev.map(row =>
          String(row.registrationNo) === String(registrationNo)
            ? { ...row, status: newStatus, comment: comment }
            : row
        )
      );

      alert("Status updated successfully!");
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Error updating status. Please try again.");
    }
  };

  // 🔹 Init DataTable
  useEffect(() => {
    if (tableRef.current && addressData.length > 0) {
      const table = $(tableRef.current).DataTable({
        destroy: true,
        data: addressData,
        columns: [
          { data: 'SrNo', title: 'Sr No' },
          { data: 'startDate', title: 'Date' },
          { data: 'registrationNo', title: 'Registration No' },
          { data: 'registerMobNo', title: 'Mobile No' },
          { data: 'aadhaarNumber', title: 'Aadhaar No' },
          { data: 'address', title: 'Address' },
          { data: 'pinCode', title: 'Pin Code' },
          { data: 'state', title: 'State' },
          { data: 'district', title: 'District' },
          { data: 'postOffice', title: 'Post Office' },
          {
            data: 'status',
            title: 'Status',
            render: function (data, type, row) {
              return `
                <select class="form-control status-dropdown" data-id="${row.registrationNo}">
                  <option value="In Progress" ${data === "In Progress" ? "selected" : ""}>In Progress</option>
                  <option value="Complete" ${data === "Complete" ? "selected" : ""}>Complete</option>
                  <option value="Rejected" ${data === "Rejected" ? "selected" : ""}>Rejected</option>
                  <option value="Refunded" ${data === "Refunded" ? "selected" : ""}>Refunded</option>
                </select>
              `;
            }
          },
          { data: 'comment', title: 'Comment' },
          {
            data: null,
            title: "Document",
            render: function (data, type, row) {
              return `<button class="btn btn-sm btn-success download-doc-btn" data-id="${row.registrationNo}">Download</button>`;
            }
          }
        ]
      });

      // Status change handler
      $(tableRef.current).off("change", ".status-dropdown").on("change", ".status-dropdown", function () {
        const registrationNo = $(this).data("id");
        const newStatus = $(this).val();
        handleStatusChange(registrationNo, newStatus);
      });

      // Document download handler
      $(tableRef.current).off('click', '.download-doc-btn').on('click', '.download-doc-btn', function () {
        const registrationNo = $(this).data("id");
        downloadDocument(registrationNo);
      });

      return () => {
        table.destroy();
        $(tableRef.current).off("change", ".status-dropdown");
        $(tableRef.current).off("click", ".download-doc-btn");
      };
    }
  }, [addressData]);

  // 🔹 Download uploaded document
  const downloadDocument = async (registrationNo) => {
    try {
      const authToken = localStorage.getItem("authToken");

      const response = await fetch(`${API_BASE_URL}/AddressUpdate/DownloadDocument/${registrationNo}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to download document");
      }

      const blob = await response.blob();
      const contentType = response.headers.get("Content-Type");
      const extension = contentType?.split("/")[1] || "file";

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `AddressUpdate_${registrationNo}.${extension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  return (
    <table
      ref={tableRef}
      id="productsTable"
      className="table table-bordered table-hover table-product"
      style={{ width: '100%' }}
    >
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th>Date</th>
          <th>Registration No</th>
          <th>Mobile No</th>
          <th>Aadhaar No</th>
          <th>Address</th>
          <th>Pin Code</th>
          <th>State</th>
          <th>District</th>
          <th>Post Office</th>
          <th>Status</th>
          <th>Comment</th>
          <th>Document</th>
        </tr>
      </thead>
    </table>
  );
};

export default AddressUpdateAdminReport;


// import React, { useEffect, useRef, useState } from 'react';
// import $ from 'jquery';
// import 'datatables.net-bs4';
// import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { jsPDF } from "jspdf";
// import "jspdf-autotable";

// const AddressUpdateAdminReport = () => {
//     const [addressData, setAddressData] = useState([]);
//     const tableRef = useRef(null);

//     useEffect(() => {
//         const fetchAddressData = async () => {
//             try {
//                 const authToken = localStorage.getItem("authToken");

//                 const response = await fetch('http://localhost:5121/api/AddressUpdate/GetAddressRecords', {
//                     // const response = await fetch('https://apiv2.chakran.in/api/AddressUpdate/GetAddressRecords', {
//                     method: 'GET',
//                     headers: {
//                         Authorization: `Bearer ${authToken}`,
//                     }
//                 });

//                 if (!response.ok) {
//                     throw new Error(`HTTP error! Status: ${response.status}`);
//                 }

//                 let data = await response.json();

//                 data = data.map((record, index) => ({
//                     ...record,
//                     SrNo: index + 1
//                 }));

//                 setAddressData(data);
//             } catch (error) {
//                 console.error('Failed to fetch address update records:', error);
//             }
//         };

//         fetchAddressData();
//     }, []);

//     // Function to update status
//     const handleStatusChange = async (registrationNo, newStatus) => {
//         const comment = prompt("Enter comment for this status change:");
//         if (!comment) return;

//         try {
//             const authToken = localStorage.getItem("authToken");

//             const response = await fetch(`http://localhost:5121/api/AddressUpdate/updateStatus/${registrationNo}`, {
//                 // const response = await fetch(`https://apiv2.chakran.in/api/AddressUpdate/updateStatus/${registrationNo}`, {
//                 method: "PUT",
//                 headers: {
//                     "Content-Type": "application/json",
//                     Authorization: `Bearer ${authToken}`,
//                 },
//                 body: JSON.stringify({ status: newStatus, comment }),
//             });

//             if (!response.ok) throw new Error("Failed to update status");

//             // Update UI state
//             setAddressData(prev =>
//                 prev.map(row =>
//                     row.registrationNo === registrationNo
//                         ? { ...row, status: newStatus, comment }
//                         : row
//                 )
//             );

//         } catch (error) {
//             console.error("Error updating status:", error);
//         }
//     };

//     useEffect(() => {
//         if (tableRef.current && addressData.length > 0) {
//             const table = $(tableRef.current).DataTable({
//                 destroy: true,
//                 data: addressData,
//                 columns: [
//                     { data: 'SrNo', title: 'Sr No' },
//                     { data: 'startDate', title: 'Date' },
//                     { data: 'registerMobNo', title: 'Mobile No' },
//                     { data: 'aadhaarNumber', title: 'Aadhaar No' },
//                     { data: 'registrationNo', title: 'Registration No' },
//                     {
//                         data: 'status',
//                         title: 'Status',
//                         render: function (data, type, row) {
//                             return `
//                                 <select class="form-control status-dropdown" data-id="${row.registrationNo}">
//                                     <option value="In Progress" ${data === "In Progress" ? "selected" : ""}>In Progress</option>
//                                     <option value="Complete" ${data === "Complete" ? "selected" : ""}>Complete</option>
//                                     <option value="Rejected" ${data === "Rejected" ? "selected" : ""}>Rejected</option>
//                                     <option value="Refunded" ${data === "Refunded" ? "selected" : ""}>Refunded</option>
//                                 </select>
//                             `;
//                         }
//                     },
//                     { data: 'comment', title: 'Comment' },
//                     {
//                         data: null,
//                         title: "Submitted Form",
//                         render: function (data, type, row) {
//                             return `<button class='btn btn-sm btn-primary download-btn' data-id='${row.registrationNo}'>Download PDF</button>`;
//                         },
//                     },
//                     {
//                         data: null,
//                         title: "Download",
//                         render: function (data, type, row) {
//                             return `<button class='btn btn-sm btn-success download-doc-btn' data-id='${row.registrationNo}'>Download</button>`;
//                         },
//                     }
//                 ]
//             });

//             // Handle status change
//             $(tableRef.current).on("change", ".status-dropdown", function () {
//                 const registrationNo = $(this).attr("data-id");
//                 const newStatus = $(this).val();
//                 handleStatusChange(registrationNo, newStatus);
//             });

//             $('#productsTable tbody').off('click', '.download-btn').on('click', '.download-btn', function () {
//                 const registrationNo = $(this).data("id");
//                 downloadPDF(registrationNo, "form");
//             });

//             $('#productsTable tbody').off('click', '.download-doc-btn').on('click', '.download-doc-btn', function () {
//                 const registrationNo = $(this).data("id");
//                 downloadPDF(registrationNo, "document");
//             });

//             return () => {
//                 table.destroy();
//                 $(tableRef.current).off("change", ".status-dropdown");
//             };
//         }
//     }, [addressData]);

//     const downloadPDF = async (registrationNo, type) => {
//         try {
//             const authToken = localStorage.getItem("authToken");

//             const endpoint = type === "form"
//                 ? `http://localhost:5121/api/AddressUpdate/DownloadPdf/${registrationNo}`
//                 : `http://localhost:5121/api/AddressUpdate/DownloadDocument/${registrationNo}`;

//             // const endpoint = type === "form"
//             //     ? `https://apiv2.chakran.in/api/AddressUpdate/DownloadPdf/${registrationNo}`
//             //     : `https://apiv2.chakran.in/api/AddressUpdate/DownloadDocument/${registrationNo}`;

//             const response = await fetch(endpoint, {
//                 method: "GET",
//                 headers: {
//                     Authorization: `Bearer ${authToken}`,
//                 },
//             });

//             if (!response.ok) {
//                 throw new Error(`Failed to download file: ${response.status}`);
//             }

//             const blob = await response.blob();
//             const contentType = response.headers.get("Content-Type");
//             const fileExtension = contentType.split("/")[1] || "pdf";

//             const url = window.URL.createObjectURL(blob);
//             const a = document.createElement("a");
//             a.href = url;
//             a.download = `AddressUpdate_${type}_${registrationNo}.${fileExtension}`;
//             document.body.appendChild(a);
//             a.click();
//             document.body.removeChild(a);
//         } catch (error) {
//             console.error("Download error:", error);
//         }
//     };

//     return (
//         <table
//             ref={tableRef}
//             id="productsTable"
//             className="table table-bordered table-hover table-product"
//             style={{ width: '100%' }}
//         >
//             <thead>
//                 <tr>
//                     <th>Sr. No.</th>
//                     <th>Date</th>
//                     <th>Mobile No</th>
//                     <th>Aadhaar No</th>
//                     <th>Registration No</th>
//                     <th>Status</th>
//                     <th>Comment</th>
//                     <th>Submitted Form</th>
//                     <th>Download</th>
//                 </tr>
//             </thead>
//         </table>
//     );
// };

// export default AddressUpdateAdminReport;
